export default [
    {
        path: 'mapa-dia',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-mapa-dia' */
            '@/views/exame-laboratorial/mapa-dia/Index'
        ),
        redirect: 'mapa-dia/create',
        children: [
            {
                name: 'exame-laboratorial-mapa-dia-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-mapa-dia' */
                    '@/views/exame-laboratorial/mapa-dia/Form.vue'
                ),
            },
        ],
    }
]